import { RegexEditor } from '../utils/regex_editor'
import { _punctuation } from './_punctuation'

export const punctuation = new RegexEditor(/^([\spunctuation])/)
  .replace(/punctuation/g, _punctuation)
  .getRegex()
